export const changeendDateReducer = (state = '2024-12-31', action) => {
  switch (action.type) {
    case "CHANGE_END_DATE":
      return action.payload.endDateSelected;
    default:
      return state;
  }
};
